"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Context", {
  enumerable: true,
  get: function get() {
    return _Context.Context;
  }
});
Object.defineProperty(exports, "ContextProvider", {
  enumerable: true,
  get: function get() {
    return _Context.ContextProvider;
  }
});

var _Context = require("./Context");